import React from "react";

const ViewBadge = () => {
  return <div></div>;
};

export default ViewBadge;
